interface ApiBackend {
    label: string;
    apiHost: string;
    apiPrefix: string;
    protocol?: "http" | "https";
    defaultApiKey?: string;
}

export const apiBackends: ApiBackend[] = [
    {
        label: "test",
        apiHost: "test.pilw.io",
        apiPrefix: "",
    },
    {
        label: "demo",
        apiHost: "demo.warren.io",
        apiPrefix: "/_p/demo",
    },
    {
        label: "3NV",
        apiHost: "dashboard.3nv.io",
        apiPrefix: "/_p/metal",
    },
    {
        label: "Atomidata",
        apiHost: "app.atomidata.fi",
        apiPrefix: "/_p/atomidata",
    },
    {
        label: "Cloudaxion (Dataxion)",
        apiHost: "app.cloudaxion.net",
        apiPrefix: "/_p/cloudaxion",
    },
    {
        label: "Daruur (Dalkom)",
        apiHost: "app.daruur.space",
        apiPrefix: "/_p/daruur",
    },
    {
        label: "Denv-R",
        apiHost: "app.denv-r.com",
        apiPrefix: "/_p/denvr",
    },
    {
        label: "HostZop",
        apiHost: "cloud.hostzop.com",
        apiPrefix: "/_p/hostzop",
    },
    {
        label: "IDCloudHost",
        apiHost: "console.idcloudhost.com",
        apiPrefix: "/_p/idch",
    },
    {
        label: "InSpace (ReadyIDC)",
        apiHost: "app.inspace.cloud",
        apiPrefix: "/_p/inspace",
    },
    {
        label: "Nforce (Prodforce)",
        apiHost: "app.nforce.cloud",
        apiPrefix: "/_p/nforce",
    },
    {
        label: "Rackdog",
        apiHost: "cloud.rackdog.com",
        apiPrefix: "/_p/rackdog",
    },
    {
        label: "Tenbyte (Gotipath)",
        apiHost: "console.tenbytecloud.com",
        apiPrefix: "/_p/tenbyte",
    },
    {
        label: "VDC",
        apiHost: "panel.vdc.id",
        apiPrefix: "/_p/vdc",
    },
    {
        label: "Web1",
        apiHost: "cloud.web1.fi",
        apiPrefix: "/_p/web1",
    },
    {
        label: "local",
        apiHost: "127.0.0.1:8000",
        apiPrefix: "/_p/local",
        protocol: "http",
        defaultApiKey: "dev-token",
    },
];
